/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import LabelledField from "components/labelled-field";
import useStyles from "cms/fields/_styles";
import { useSelectFieldSchema } from "cms/fields/dynamic-field";
import DisplaySettingsWrapper from "cms/fields/layout/display-settings-wrapper";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
// import useThrottle from 'hooks/useThrottle'
import { Fragment, useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import { Logger } from "cms/utils/log/logger";

const BooleanFieldItemEdit = () => {
    
    const {
        name,
        index,
        value,
        settings,
        updateListItem,
        disabled = false
    } = useContext(ListItemContext);
    
    const { t } = useTranslation();
    // const throttler = useThrottle()
    const classes = useStyles();
    const schema = useSelectFieldSchema(name);
    const { settings: schemaSettings } = schema || {};
    const { placeholder } = schemaSettings || {};
    const ph = placeholder || t("commons.placeholderText");
    
    const initialState = { value, settings };
    const [itemLocalState, setItemLocalState] = useState(initialState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((updateState, index) => {
            updateListItem(updateState, index);
        }, 500),
        [updateListItem]
    );
    
    const onChangeCheckbox = (event) => {
        const newValue = event.target.checked;
        const updateState = {
            ...itemLocalState,
            value: newValue,
        };
        // update local state immediately
        // checkbox is controlled
        setItemLocalState(updateState);
        Logger.warn("onChangeCheckbox", updateState);
        // but update server via debounce
        update(updateState, index);
    };
 
    const onChangeIfCheckedText = (event) => {
        const newValue = event.target.value;
        Logger.warn("onChangeIfCheckedText -> ", newValue);
        const updateState = {
            ...itemLocalState,
            settings: {
                ...itemLocalState?.settings,
                options: {
                    labelText: newValue,
                },
            },
        };
        // update local state immediately
        // text field uses defaultValue
        setItemLocalState(updateState);
        Logger.warn("onChangeIfCheckedText", updateState);
        // but update server via debounce
        update(updateState, index);
    };
    
    return (
        <Fragment>
            <div className='simplicity-composer-field-primary-layout'>
                <div className='simplicity-composer-field-primary'>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={itemLocalState?.value}
                                onChange={onChangeCheckbox}
                                name={name}
                                disabled={disabled}
                            />
                        }
                        label={"Enabled"}
                    />
                </div>
                <DisplaySettingsWrapper>
                    <LabelledField label={t("commons.ifCheckedDisplay")} className='labelField'>
                        {/*   sets settings.options.labelText   */}
                        <TextField
                            className={disabled ? classes.disabled : ""}
                            fullWidth={true}
                            placeholder={ph}
                            defaultValue={itemLocalState?.settings?.options?.labelText}
                            disabled={disabled}
                            variant='standard'
                            onChange={onChangeIfCheckedText}
                        />
                    </LabelledField>
                </DisplaySettingsWrapper>
            </div>
        </Fragment>
    );
};
BooleanFieldItemEdit.displayName = "BooleanFieldItemEdit";
export { BooleanFieldItemEdit };
